/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useMemo} from 'react'

import { const_var, params } from '../../../../../redux/reducers/reducer';

import LineModel from '../../LineModel'
import DimensionValue from '../../DimensionValue';
import { convertFeet } from '../../../../../utils/ConvertFeet';

const CenterArrow = () => {
    const [topPosition, setTopPosition] = useState(0)
    useMemo(() => {
        let regularHeight = 0;
        
        if (params.p_r_s === 1) {
            regularHeight = 0.4;
        } else if (params.p_r_s === 2) {
            regularHeight = 0;
        } else if (params.p_r_s === 3) {
            regularHeight = 0;
        }
        
        setTopPosition(params.p_h + (params.singleSlope ? 0 : (params.p_r_p / 12) * params.p_w / 2) + regularHeight) 
    
    }, [params.p_r_p, params.p_h, params.singleSlope, params.p_r_s, params.p_w])


    return const_var.callMesure && (
        <>
            <group name='front-wall' position={[params.singleSlope ? params.p_w / 2 : 0, 0, 0]}>
                <DimensionValue position={[0, params.singleSlope ? topPosition / 2 : topPosition - 1.8, params.p_d / 2 + (params.singleSlope ? 1.1 : 0.7)]} rotation={[0, params.singleSlope ? Math.PI / 2 : 0, 0]} checkBackSide={true} value={convertFeet(topPosition)+'H'} slopeAngle={0} />
                <LineModel length={topPosition - 0.3} position={[(params.singleSlope ? 0.2 : 0), topPosition / 2, params.p_d / 2 + 0.3]} color='#2F7CBF' />
            </group>
            <group name='back-wall' position={[params.singleSlope ? params.p_w / 2 : 0, 0, 0]}>
                <DimensionValue position={[0, params.singleSlope ? topPosition / 2 : topPosition - 1.8, -(params.p_d / 2 + (params.singleSlope ? 0.1 : 0.7))]} rotation={[0, Math.PI, 0]} checkBackSide={true} value={convertFeet(topPosition)+'H'} slopeAngle={0} />
                <LineModel length={topPosition - 0.3} position={[(params.singleSlope ? 0.2 : 0), topPosition / 2, -(params.p_d / 2 + 0.3)]} color='#2F7CBF' />
            </group>
        </>
    )
}

export default CenterArrow